/* @flow */
import * as React from 'react';

import './styles/AdminStatisticsChartTooltip.scss';

type Props = {
  children?: React.Node,
  title: string,
};

export default function AdminStatisticsChartTooltip({ children, title }: Props) {
  return (
    <div className="AdminStatisticsChartTooltip">
      <header className="AdminStatisticsChartTooltip-header">{title}</header>
      <div className="AdminStatisticsChartTooltip-body">{children}</div>
    </div>
  );
}
